import { render, staticRenderFns } from "./CustomKocorpLabelType1.vue?vue&type=template&id=aaa5b85c&"
import script from "./CustomKocorpLabelType1.vue?vue&type=script&lang=js&"
export * from "./CustomKocorpLabelType1.vue?vue&type=script&lang=js&"
import style0 from "./CustomKocorpLabelType1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports